import { Component, OnInit, Inject } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { EventsService } from "angular4-events";
import { DataService } from "./data.service";
// import { CutomersComponent } from './cutomers/cutomers.component';
// import { DriversComponent } from './drivers/drivers.component';

declare var firebase: any;
declare var context: any;
declare var toastr: any;
declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "app";
  pushRecivedVal: any;
  pushRecived: any;
  dashboardData1: any;
  pendingCount: any;
  constructor(
    private authService: AuthenticationService,
    private events: EventsService,
    private dataService: DataService
  ) {
    this.pushRecivedVal = this.events
      .subscribe("pushRecived")
      .subscribe((data) => {
        this.pushRecived = data;
        console.log(
          "pushRecivedpushRecivedpushRecivedpushRecived",
          this.pushRecived
        );
        console.log("notification.title", this.pushRecived.title);
        if (this.pushRecived.title === "New Business") {
          var type = 1;
          this.dataService
            .homeData(
              window.localStorage.getItem("token"),
              type,
              "",
              "",
              "",
              ""
            )
            .subscribe(
              (data) => {
                this.dashboardData1 = data;
                this.pendingCount =
                  this.dashboardData1.total_count_of_pending_businesses;
                window.localStorage.setItem(
                  "BusinessPendingCount",
                  this.pendingCount
                );
                this.events.publish("BusinessPending", this.pendingCount);
              },
              (error) => {
                console.log("error", error);
              }
            );
        }
      });
  }
  // @Inject(CutomersComponent) public parent: CutomersComponent, @Inject(DriversComponent) public parentDriver: DriversComponent
  ngOnInit() {
    function updateOfflineStatus() {
      toastr.error("There is no internet Connection access");
    }
    function updateOnlineStatus() {
      toastr.success("Internet Connected");
    }

    $(function () {
      window.addEventListener("online", updateOnlineStatus);
      window.addEventListener("offline", updateOfflineStatus);
    });
    $(function () {
      $("body").on("keydown", ":input", function (e) {
        // console.log(this.value);
        if (e.which === 32 && e.target.selectionStart === 0) {
          return false;
        }
      });
    });
    $(".dropdown").on("show.bs.dropdown", function () {
      $(this).find(".dropdown-menu").first().stop(true, true).slideDown();
    });

    // Add slideUp animation to Bootstrap dropdown when collapsing.
    $(".dropdown").on("hide.bs.dropdown", function () {
      $(this).find(".dropdown-menu").first().stop(true, true).slideUp();
    });
    var scope = this;
    const messaging = firebase.messaging();
    messaging
      .requestPermission()
      .then(function () {
        console.log("Notification permission granted.");
        // get token
        messaging
          .getToken()
          .then(function (currentToken) {
            if (currentToken) {
              console.log("generated token is:", currentToken);
              scope.authService.tokePush = currentToken;
              scope.pushNotificationFunction();
              messaging.onMessage(function (payload) {
                console.log("Message received by GCM.", payload);
                if (payload.data.type.toLowerCase() == "chat") {
                  scope.authService.messageRecieved(payload.data);
                  // scope.authService.notifyMessageReceived(payload.data);
                }
                scope.events.publish(".....", payload.data);
                const notificationTitle = payload.notification.title;
                console.log("payload.notification.type", payload.data.type);
                scope.events.publish("detectChange", payload.data.type);
                // this.pubsub.$pub('pushData', payload.notification.type);
                // if (payload.notification.type === 'new_customer') {
                //   scope.parent.customerslist();
                // }
                // if (payload.notification.type === 'new_driver') {
                //     scope.parentDriver.driverlist();
                // }
                const notificationOptions = {
                  body: payload.notification.body,
                  icon: payload.notification.icon,
                };
                // if (Notification.permission === "granted") {
                // If it's okay let's create a notification
                var notification = new Notification(
                  notificationTitle,
                  notificationOptions
                );
                notification.onclick = function (event) {
                  event.preventDefault(); // prevent the browser from focusing the Notification's tab
                  window.open(payload.notification.click_action, "_blank");
                  notification.close();
                };
                // }
                try {
                  context.notificationObserver.next(payload);
                } catch (error) {
                  console.log("no notification subscriber");
                }
              });
            } else {
              // Show permission request.
              console.log(
                "No Instance ID token available. Request permission to generate one."
              );
              // Show permission UI.
            }
          })
          .catch(function (err) {
            console.log("An error occurred while retrieving token. ", err);
          });
      })
      .catch(function (err) {
        console.log("Unable to get permission to notify.", err);
      });
    // messaging.onTokenRefresh(function() {
    //      messaging.getToken()
    //          .then(function(refreshedToken) {
    //              console.log('Token refreshed.');
    //          })
    //          .catch(function(err) {
    //              console.log('Unable to retrieve refreshed token ', err);
    //          });
    // });
  }

  pushNotificationFunction() {
    this.authService
      .pushNotify(
        window.localStorage.getItem("token"),
        this.authService.tokePush
      )
      .subscribe(
        (data) => {
          console.log("pushNotificationFunction", data);
        },
        (error) => {
          console.log("error", error);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts